/* istanbul ignore file */
import { injectable, Container } from 'inversify';

import { LocalStorage } from '@vk-hr-tek/core/local-storage';

@injectable()
export class RedirectPageService {
  private localStorage: LocalStorage;

  private readonly key = 'redirectPage';

  private namespace = '';

  constructor(container: Container, namespace = '') {
    this.localStorage = container.get(LocalStorage);
    this.namespace = namespace;
  }

  save(role: string): void {
    this.localStorage.setItem(`${this.key}${this.namespace}`, role);
  }

  get(): string {
    return this.localStorage.getItem(`${this.key}${this.namespace}`) || '';
  }

  delete(): void {
    this.localStorage.removeItem(`${this.key}${this.namespace}`);
  }
}
